import {DestinationWarehouse} from "../../../../models/DestinationWarehouse";
import {DestinationWarehouseDTO} from "../../../../models/DestinationWarehouseDTO";
export const isOzonFlag = (x: any) => !!(x?.ozon ?? x?.isOzon ?? false);

export const formatWarehouses = (warehouses?: Array<DestinationWarehouse | DestinationWarehouseDTO>) => {
    if (!warehouses || warehouses.length === 0) return "—";
    return warehouses.map((w: any) => w.warehouseName || "").filter(Boolean).join(", ");
};
